import {
  BirthCertificate,
  BirthCertificateResponseType,
} from '../birth-certificate-types';
import LZString from 'lz-string';

export const saveFileToDisc = (birthCertificate: BirthCertificate) => {
  const output = extractData(birthCertificate);
  if (!output) {
    return;
  }

  const fileExtension = getFileExtension(birthCertificate.responseType);
  const fileDownloadName = `${birthCertificate.appName}${fileExtension}`;

  // show file as download
  let blob;
  if (birthCertificate.pdfBuffer) {
    const decompressedOutput = LZString.decompressFromBase64(output);
    if (!decompressedOutput) {
      throw new Error('Could not decompress PDF buffer');
    }

    const binary = atob(decompressedOutput.replace(/\s/g, ''));
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }
    blob = new Blob([view], { type: 'application/pdf' });
  } else {
    blob = new Blob([output]);
  }
  const element = document.createElement('a');
  element.href = URL.createObjectURL(blob);
  element.download = fileDownloadName;
  document.body.appendChild(element);
  element.click();
};

export const downloadFileFromURL = (url: string) => {
  const element = document.createElement('a');
  element.href = url;
  document.body.appendChild(element);
  element.click();
};

const extractData = (birthCertificate: BirthCertificate) => {
  try {
    const { responseType } = birthCertificate;

    if (
      responseType === BirthCertificateResponseType.Json &&
      birthCertificate.json
    ) {
      return birthCertificate.json;
    } else if (
      responseType === BirthCertificateResponseType.Pdf &&
      birthCertificate.pdfBuffer
    ) {
      return birthCertificate.pdfBuffer;
    } else if (
      responseType === BirthCertificateResponseType.Html &&
      birthCertificate.html
    ) {
      return birthCertificate.html;
    }

    return null;
  } catch {
    return null;
  }
};

const getFileExtension = (type: BirthCertificateResponseType) => {
  switch (type) {
    case BirthCertificateResponseType.Json:
      return '.json';
    case BirthCertificateResponseType.Pdf:
      return '.pdf';
    case BirthCertificateResponseType.Html:
      return '.html';
    default:
      return '.json';
  }
};
